const nav = document.querySelector('.MobileNavigation');

if (nav) {
    const pageLinks = Array.from(nav.querySelectorAll('[data-page-link]'));
    const backs = Array.from(nav.querySelectorAll('[data-back]'));

    pageLinks.forEach((link) => {
        link.addEventListener('click', (e) => {
            e.preventDefault();

            const page = nav.querySelector(`[data-page="${link.dataset.pageLink}"]`);
            page.classList.remove('translate-x-full');
        });
    });

    backs.forEach((link) => {
        link.addEventListener('click', (e) => {
            e.preventDefault();
            const page = link.closest('[data-page]');
            page.classList.add('translate-x-full');
        });
    });
}
